// Utility function to clean candidate form data before submission
export const cleanFormDataCandidate = (values) => {
  const cleanedValues = { ...values }

  // Fields that should never be deleted
  const protectedFields = ["resume", "coverLetter"];

  // Utility to check if field should be deleted
  const shouldDelete = (field, value) => {
    if (protectedFields.includes(field)) return false;
    return value === "" || value === null || value === undefined;
  };

  // Remove empty string/null/undefined for ObjectId fields
  const objectIdFields = ["owner"];
  objectIdFields.forEach((field) => {
    if (shouldDelete(field, cleanedValues[field])) {
      delete cleanedValues[field];
    }
  });

  // Remove empty string/null/undefined for optional text fields
  const optionalTextFields = ["city", "currentEmployer", "phone"];
  optionalTextFields.forEach((field) => {
    if (shouldDelete(field, cleanedValues[field])) {
      delete cleanedValues[field];
    }
  });

  // Remove empty string/null/undefined for dropdown/select fields
  const selectFields = ["status", "state", "source", "highestQualification", "noticePeriod", "currentJobTitle"];
  selectFields.forEach((field) => {
    if (shouldDelete(field, cleanedValues[field])) {
      delete cleanedValues[field];
    }
  });

  // Handle array fields - remove if empty array or empty/null/undefined
  const arrayFields = ["skills"];
  arrayFields.forEach((field) => {
    const value = cleanedValues[field];
    if (protectedFields.includes(field)) return;

    if (Array.isArray(value) && value.length === 0) {
      delete cleanedValues[field];
    } else if (shouldDelete(field, value)) {
      delete cleanedValues[field];
    }
  });

  // Remove numeric fields if 0, empty, null, or undefined
  const numericFields = ["experienceYears"];
  numericFields.forEach((field) => {
    const value = cleanedValues[field];
    if (protectedFields.includes(field)) return;

    if (
      value === "" ||
      value === null ||
      value === undefined 
      // value === 0
    ) {
      delete cleanedValues[field];
    }
  });

  return cleanedValues;
};
